// 로깅 유틸리티 - VITE_DEV_MODE에 따라 제어
// VITE_DEV_MODE=true: 모든 로그 출력 (개발 모드)
// VITE_DEV_MODE=false: 로그 차단 (운영 모드)
// 
// 주의: consoleOverride.js가 전역 console을 제어하므로
// logger는 originalConsole을 사용하여 충돌 방지

import { originalConsole } from './consoleOverride';

const isDevMode = import.meta.env.VITE_DEV_MODE === 'true';

const logger = {
  debug: (...args) => {
    if (isDevMode) {
      originalConsole.log('[DEBUG]', ...args);
    }
    // 운영 모드에서는 아무것도 하지 않음
  },
  
  info: (...args) => {
    if (isDevMode) {
      originalConsole.info('[INFO]', ...args);
    }
    // 운영 모드에서는 아무것도 하지 않음
  },
  
  warn: (...args) => {
    if (isDevMode) {
      originalConsole.warn('[WARN]', ...args);
    }
    // 운영 모드에서는 아무것도 하지 않음
  },
  
  error: (...args) => {
    if (isDevMode) {
      originalConsole.error('[ERROR]', ...args);
    }
    // 운영 모드에서는 에러도 차단
    // 프로덕션 환경에서는 백엔드로 에러 전송 가능
    if (import.meta.env.PROD && !isDevMode) {
      // sendErrorToBackend(args);
    }
  },
  
  // 프록시 로그용 특별 메서드
  proxy: (...args) => {
    if (isDevMode) {
      originalConsole.log('[PROXY]', ...args);
    }
    // 운영 모드에서는 아무것도 하지 않음
  }
};

export default logger;